(function () {
  if (window.monelloCartUpsellInitialized) return;
  window.monelloCartUpsellInitialized = true;

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.monello-upsell-add');

    if (!button || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    const normalText = button.querySelector('.monello-upsell-button__normal');
    const loadingText = button.querySelector('.monello-upsell-button__loading');
    const upsellBox = button.closest('.monello-cart-upsells');
    const errorMessage = upsellBox?.querySelector('.monello-upsell-error');

    if (!variantId) {
      if (errorMessage) errorMessage.hidden = false;
      return;
    }

    button.disabled = true;

    if (normalText) normalText.hidden = true;
    if (loadingText) loadingText.hidden = false;
    if (errorMessage) errorMessage.hidden = true;

    try {
      const root = window.Shopify?.routes?.root || '/';

      const addResponse = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        })
      });

      if (!addResponse.ok) {
        const errorData = await addResponse.json().catch(function () {
          return {};
        });

        throw new Error(
          errorData.description || 'Produkt konnte nicht hinzugefügt werden.'
        );
      }

      /*
       * Auf der normalen Warenkorbseite:
       * Seite neu laden, damit Produkt, Summe und Upsell korrekt aktualisiert werden.
       */
      if (window.location.pathname.includes('/cart')) {
        window.location.reload();
        return;
      }

      /*
       * Im Cart Drawer:
       * Drawer-Inhalt ohne Seitenwechsel neu laden.
       */
      const sectionResponse = await fetch(
        root + '?sections=cart-drawer-section',
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!sectionResponse.ok) {
        throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
      }

      const sections = await sectionResponse.json();
      const sectionHtml = sections['cart-drawer-section'];

      if (!sectionHtml) {
        throw new Error('Die Cart-Drawer-Section wurde nicht gefunden.');
      }

      const parsedDocument = new DOMParser().parseFromString(
        sectionHtml,
        'text/html'
      );

      const newDrawerInner = parsedDocument.querySelector(
        '#cart-drawer .cart-drawer__inner'
      );

      const currentDrawerInner = document.querySelector(
        '#cart-drawer .cart-drawer__inner'
      );

      if (!newDrawerInner || !currentDrawerInner) {
        throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
      }

      currentDrawerInner.replaceWith(newDrawerInner);
    } catch (error) {
      console.error('Monello Cart Upsell:', error);

      button.disabled = false;

      if (normalText) normalText.hidden = false;
      if (loadingText) loadingText.hidden = true;
      if (errorMessage) {
        errorMessage.textContent =
          error.message || 'Das Produkt konnte leider nicht hinzugefügt werden.';
        errorMessage.hidden = false;
      }
    }
  });
})();
